export function StripeApiKey() {
  var staging_key = 'pk_test_1rNOhFg7YTTk0uqwoHLo2uJH'
  var production_key = 'pk_live_hODiAiNYt9jiBcC9rh5hvEhh'
  var loc = window.location;
  var url = new URL(loc)
  var enviorment_url = url.hostname
  if(enviorment_url == "booking.getspiffy.com"){
    return production_key
  }
  else {
    return staging_key
  }
}



// WEBPACK FOOTER //
// ./src/utils/ApiKeys.js